angular.module('satv.track')
    .factory('SelectTrackModal', ['config', 'Modal', function(config, Modal) {
        'use strict';
        return {
            open: function(params, data) {
                return Modal.create(
                    config.templateRoot + '/templates/smf/modals/select-track',
                    params,
                    data
                );
            }
        };
    }]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/services/SelectTrackModal.js